/**
 * Enum for visual selection modes used by the select step.
 */
export enum SelectionMode {
  /**
   * Select with a dropdown.
   */
  DROPDOWN = "DROPDOWN",

  /**
   * Select with buttons including an icon.
   */
  BUTTONS = "BUTTONS",

  /**
   * Select with icons only.
   */
  ICONS = "ICONS",
}
